/**
 * Concordância de número nos textos montados na tela.
 *
 * A visão geral monta quase toda a sua prosa a partir de contagens que vêm do
 * middleware ("1 divergência", "3 divergências"), e o servidor nunca manda
 * frase pronta. Sem isto, cada bloco resolvia o plural do seu jeito e o painel
 * escrevia "1 operações retidas".
 */
export function plural(quantidade: number, singular: string, plural: string): string {
  return `${String(quantidade)} ${quantidade === 1 ? singular : plural}`;
}
